export default __webpack_public_path__ + "static/media/block-fodder.62db9917.svg";